import request from '@/plugins/axios'
import * as Interface from '@/api/permissions.d'

/** S 管理员 **/
// 管理员列表
export const apiAuthPlatformAdminList = (params: Interface.AdminList_Req): Promise<Interface.AdminList_Res> =>
    request.get('/auth.platform_admin/lists', { params })

// 管理员详情
export const apiAuthPlatformAdminDetail = (
    params: Interface.AdminDetail_Req
): Promise<Interface.AdminDetail_Res> => request.get('/auth.platform_admin/detail', { params })

// 添加管理员
export const apiAuthPlatformAdminAdd = (data: Interface.AdminAdd_Req): Promise<any> =>
    request.post('/auth.platform_admin/add', data)

// 删除管理员
export const apiAuthPlatformAdminDel = (data: Interface.AdminDelete_Req): Promise<any> =>
    request.post('/auth.platform_admin/del', data)

// 编辑管理员
export const apiAuthPlatformAdminEdit = (data: Interface.AdminEdit_Req): Promise<any> =>
    request.post('/auth.platform_admin/edit', data)

/** E 管理员 **/

/** S 角色 **/
// 角色列表
export const apiAuthPlatformGroupLists = (params?: Interface.RoleList_Req): Promise<Interface.RoleList_Res> =>
    request.get('/auth.platform_auth_group/lists', { params })

// 角色详情
export const apiAuthPlatformGroupDetail = (
    params: Interface.RoleDetail_Req
): Promise<Interface.RoleDetail_Res> => request.get('/auth.platform_auth_group/detail', { params })

// 添加角色
export const apiAuthPlatformGroupAdd = (data: Interface.RoleAdd_Req): Promise<any> =>
    request.post('/auth.platform_auth_group/add', data)

// 编辑角色
export const apiAuthPlatformGroupEdit = (data: Interface.RoleEdit_Req): Promise<any> =>
    request.post('/auth.platform_auth_group/edit', data)

// 删除角色
export const apiAuthPlatformGroupDel = (data: Interface.RoleDelete_Req): Promise<any> =>
    request.post('/auth.platform_auth_group/del', data)

// 权限菜单
export const apiAuthMenu = () => request.post('/config/getMenu')
/** E 角色 **/

// 菜单列表
export const apiAuthPlatformRuleLists = (params: any): Promise<any> => request.get('/auth.platform_auth_rule/lists', { params })
// 菜单列表删除
export const apiAuthPlatformRuleDel = (data: any): Promise<any> => request.post('/auth.platform_auth_rule/del', data)
// 菜单列表编辑
export const apiAuthPlatformRuleEdit = (data: any): Promise<any> => request.post('/auth.platform_auth_rule/edit', data)
// 菜单列表新增
export const apiAuthPlatformRuleAdd = (data: any): Promise<any> => request.post('/auth.platform_auth_rule/add', data)
// 菜单列表详情
export const apiAuthPlatformRuleDetail = (params: any): Promise<any> => request.get('/auth.platform_auth_rule/detail', { params })
// 所有菜单列表
export const apiAuthPlatformRuleAll = (params: any): Promise<any> => request.get('/auth.platform_auth_rule/all', { params })
